import React from 'react';

export default function StatusBar({ phase, turn, pendingBattle, lastMoveNote, onNewGame }) {
  if (phase === "end") {
    let winnerText;
    if (turn === "tie") {
      winnerText = "It's a tie!";
    } else if (turn === "wait2" || turn === "1") {
      // local: wait2 = P1 won; online: turn = winning player "1"
      winnerText = "Player 1 wins! 🎉";
    } else {
      // local: wait1 = P2 won; online: turn = winning player "2"
      winnerText = "Player 2 wins! 🎉";
    }
    return (
      <div className="game-over-banner">
        <div className="game-over-text">{winnerText}</div>
        {onNewGame && <button onClick={onNewGame}>New Game</button>}
      </div>
    );
  }

  if (pendingBattle) {
    return <div className="status-text">Resolve the battle to continue</div>;
  }

  if (turn === "wait1") {
    return <div className="status-text">Hand off to Player 1 — click anywhere to begin their turn</div>;
  }

  if (turn === "wait2") {
    return <div className="status-text">Hand off to Player 2 — click anywhere to begin their turn</div>;
  }

  if (phase === "player1_setup") {
    return <div className="status-text">Player 1: Place your pieces in the bottom 3 rows</div>;
  }

  if (phase === "player2_setup") {
    return <div className="status-text">Player 2: Place your pieces in the top 3 rows</div>;
  }

  return (
    <div>
      <div className="status-text">Current Turn: Player {turn}</div>
      {lastMoveNote && (
        <div className="status-text last-move-note">{lastMoveNote}</div>
      )}
    </div>
  );
}
